// extracted by mini-css-extract-plugin
export var fadeInOut = "_2l-3";
export var icon = "_2l-4";
export var savedIndicator = "_2l-2";
export var savingIndicator = "_2l-0";
export var spin = "_2l-1";